export default __webpack_public_path__ + "static/media/home-light-theme.6c53196d.png";